// extracted by mini-css-extract-plugin
export default {"layout":"RunHistory_layout__2-jmK","headerCard":"RunHistory_headerCard__fHZS1","headerTitleRow":"RunHistory_headerTitleRow__XnWHu"};